import ip from 'icepick';
import {
  SET_PROPOSAL_DETAILS,
  UPDATE_ADDONS,
  UPDATE_IDV,
  UPDATE_NCB,
  UPDATE_VEHICLE_FILTER_DATA,
  RESET_INSURANCE,
  UPDATING_QUOTE,
  SET_REQUEST_ID,
  SET_QUOTES_PAYLOAD,
  SET_ACTIVE_TAB,
} from './type';
import { TabBarEnums } from '../utils/constants';

const initialState = ip.freeze({
  idv: {
    currentIdv: null,
    previousIdv: null,
    min: null,
    max: null,
    recommended: null,
    showIDV: false,
  },
  ncb: {
    ncbDiscount: null,
    showNcbOption: null,
    isNcbEditable: null,
    isPrevYearClaimMade: null,
    options: null,
  },
  proposalData: null,
  selectedAddons: [],
  vehicleFilterData: null,
  isQuoteUpdating: false,
  activeTab: TabBarEnums.Recommended,
  requestId: null,
  quotesPayload: null,
});

const carInsuranceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RESET_INSURANCE: {
      state = ip.assign(state, initialState);
      return state;
    }
    case UPDATE_VEHICLE_FILTER_DATA: {
      state = ip.setIn(state, ['vehicleFilterData'], payload);
      return state;
    }
    case UPDATE_IDV: {
      state = ip.setIn(state, ['idv'], payload);
      return state;
    }
    case UPDATE_NCB: {
      state = ip.setIn(state, ['ncb'], payload);
      return state;
    }
    case UPDATE_ADDONS: {
      state = ip.setIn(state, ['selectedAddons'], payload);
      return state;
    }
    case UPDATING_QUOTE: {
      state = ip.setIn(state, ['isQuoteUpdating'], payload);
      return state;
    }
    case SET_PROPOSAL_DETAILS: {
      state = ip.setIn(state, ['proposalData'], payload);
      return state;
    }
    case SET_REQUEST_ID: {
      state = ip.setIn(state, ['requestId'], payload);
      return state;
    }
    case SET_QUOTES_PAYLOAD: {
      state = ip.setIn(state, ['quotesPayload'], payload);
      return state;
    }
    case SET_ACTIVE_TAB: {
      state = ip.setIn(state, ['activeTab'], payload);
      return state;
    }
    default: {
      return state;
    }
  }
};

export default carInsuranceReducer;
